import i18n from '../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import _ from 'lodash';
import moment from "moment";
import {SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";
import {store} from "@/plugins/vuex";

export default class LotSearch extends BaseModel {
  department_uuid = null;
  category_uuid = null;
  receipt_no = null;
  title = null;
  item_no = null;
  status = null;
  lot_no = null;
  start_date = null;
  end_date = null;
  negotiation_status = null;
  customer_uuid = null;
  sale = null;
  account_manager_uuid = null;
  invoice_status = [];
  collected = false;
  sold_via_negotiation = false;
  auction_date_uuid = null;
  unsettled = false;
  reserve_type = null;
  auction_collection_uuid = null;
  paddle_number = null;
  item_location_uuid = null;
  use_images_for_auction_gallery = null;
  receipt_contract_status = null;
  source_of_sale = [];
  proposal_status = null;
  proposal_suggestion = null;
  images_value = null;
  hide_lot = null;
  rep_user_uuid = null;
  cataloguing_lifecycle = [];
  photography_lifecycle = [];

  rules = {};

  attributeLabels = {
    department_uuid: i18n.t('Department'),
    category_uuid: i18n.t('Category'),
    receipt_no: i18n.t('Receipt'),
    title: i18n.t('Title'),
    item_no: i18n.t('Item Number'),
    status: i18n.t('Status'),
    lot_no: i18n.t('Lot Number'),
    start_date: i18n.t('Start Date'),
    end_date: i18n.t('End Date'),
    invoice_status: i18n.t('Invoice Status'),
    collected: i18n.t('Collected'),
    sale: i18n.t('Sale'),
    sold_via_negotiation: i18n.t('Sold via Negotiation'),
    specialist_uuid: i18n.t('Specialist'),
    auction_date_uuid: i18n.t('Session'),
    unsettled: i18n.t('Unsettled'),
    reserve_type: i18n.t('Reserve Type'),
    auction_collection_uuid: i18n.t('Collection'),
    item_location_uuid: i18n.t('Item Location'),
    use_images_for_auction_gallery: i18n.t('Auction Gallery'),
    receipt_contract_status: i18n.t('Consignment Status'),
    source_of_sale: i18n.t('Auction Provider'),
    proposal_status: i18n.t('Proposal Status'),
    proposal_suggestion: i18n.t('Proposal Suggestion'),
    has_images: i18n.t('Has Images'),
    cataloguing_lifecycle: i18n.t('Cataloguing Lifecycle'),
    photography_lifecycle: i18n.t('Photography Lifecycle'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    delete data.department;
    delete data.customer;
    delete data.user;
    delete data.recommended_by_user;
    delete data.department;
    delete data.category;
    delete data.specialist;
    delete data.bidder;
    delete data.rep_user;

    if (data.start_date) {
      data.start_date = moment(data.start_date).format(SYSTEM_DATE_FORMAT);
    }
    if (data.end_date) {
      data.end_date = moment(data.end_date).format(SYSTEM_DATE_FORMAT);
    }

    delete data.department;
    delete data.category;
    delete data.specialist;

    data.source_of_sale = data.source_of_sale.join(',')
    data.invoice_status = data.invoice_status.join(',')
    data.cataloguing_lifecycle = data.cataloguing_lifecycle ? data.cataloguing_lifecycle.join(',') : null;
    data.photography_lifecycle = data.photography_lifecycle ? data.photography_lifecycle.join(',') : null;
    data.collected ? data.collected = 'true' : delete data.collected
    data.unsettled ? data.unsettled = 'true' : delete data.unsettled
    data.sold_via_negotiation ? data.sold_via_negotiation = 'true' : delete data.sold_via_negotiation
    data.use_images_for_auction_gallery ? data.use_images_for_auction_gallery = 'true' : delete data.use_images_for_auction_gallery
    data.has_images ? data.has_images = 'true' : delete data.has_images

    if (store.state && store.state.global && store.state.global.dynamicFieldsFilters) {
      let inventoryDynamicFieldsFilters = store.state.global.dynamicFieldsFilters.inventories;
      if (inventoryDynamicFieldsFilters && inventoryDynamicFieldsFilters.length > 0) {
        for (let field of inventoryDynamicFieldsFilters) {
          if (field.type === 'checkbox') {
            data[field.key] ? data[field.key] = 'true' : delete data[field.key]
          }
        }
      }
    }

    if (data.images_value === 'has_images') {
      data.has_images = 'true'
    } else if (data.images_value === 'without_images') {
      data.no_images = 'true'
    }
    delete data.images_value

    if (data.item_location_uuid) {
      data.item_location_uuid_deep = data.item_location_uuid
      delete data.item_location_uuid
    }

    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(LotSearch);
